import { ShapeState } from './shape.types';

import { RootState } from '~/redux/store';

export const selectSelectedPredefinedShape = ({
  shape,
}: RootState): ShapeState['selectedPredefinedShape'] =>
  shape.selectedPredefinedShape;

export const selectSelectedDrawingObjectName = ({
  shape,
}: RootState): ShapeState['selectedDrawingObjectName'] =>
  shape.selectedDrawingObjectName;

export const selectSelectedDrawingTab = ({
  shape,
}: RootState): ShapeState['selectedDrawingTab'] => shape.selectedDrawingTab;

export const selectPendingEditShape = ({
  shape,
}: RootState): ShapeState['pendingEditShape'] => shape.pendingEditShape;
